export const agenda = {
  agendaDuration: 'längd',
  agendaCurtainCopy: 'Kopiera länk',
  agendaCurtainFlag: 'Flagga innehåll',
  agendaCurtainFlagSent: 'Innehåll rapporterat',
  agendaLinkCopied: 'Länk kopierad!',
  agendaStartsAt: 'Börjar kl. ',
  agendaEndsAt: 'Slutar kl. ',
  agendaSpeakers: 'Föreläsare',
  agendaSeeAllSpeakers: 'Se alla',
  agendaAddToSchedule: 'Lägg till i min planering',
  agendaRemoveFromSchedule: 'Ta bort från min planering',
  agendaAddedToSchedule: 'Tillagd i min planering!',
  agendaRemovedFromSchedule: 'Borttagen från min planering!',
  agendaCalendar: 'Kalender',
  agendaAddToCalendar: 'Lägga till i systemkalendern?',
  agendaCalendarSkip: 'Hoppa över',
  agendaCalendarAdd: 'Lägg till',
  agendaNow: 'NU',
  agendaModerators: 'Moderatorer'
}
